import { Linking, Platform, ActionSheetIOS } from "react-native";

export async function openMapByLatLng(lat: string, lng: string) {
  const latLng = `${lat},${lng}`;

  if (Platform.OS === 'ios') {
    const options = ['Annuler'];
    const urls = [null]; // même index que `options`

    if (await Linking.canOpenURL('maps://')) {
      options.push('Plans');
      urls.push(`maps://0,0?q=${latLng}`);
    }

    options.push('Google Maps');
    urls.push(`comgooglemaps://?q=${latLng}`);

    options.push('Waze');
    urls.push(`https://waze.com/ul?ll=${latLng}&navigate=yes`);

    ActionSheetIOS.showActionSheetWithOptions(
      {
        options,
        cancelButtonIndex: 0,
        title: 'Choisissez une application',
        message: 'Quelle application souhaitez-vous utiliser ?'
      },
      (buttonIndex) => {
        if (buttonIndex !== 0 && urls[buttonIndex]) {
          Linking.openURL(urls[buttonIndex]).catch(() => {
            const selected = options[buttonIndex];
            if (selected === 'Google Maps') {
              Linking.openURL(`https://www.google.com/maps/search/?api=1&query=${latLng}`);
            } else if (selected === 'Waze') {
              Linking.openURL(`https://waze.com/ul?ll=${latLng}&navigate=yes`);
            } else {
              console.error(`Impossible d'ouvrir ${selected}`);
            }
          });
        }
      }
    );
  }
  else {
    const url = Platform.select({
      android: `geo:0,0?q=${latLng}`,
      web: `https://www.google.fr/maps?q=${latLng}`
    });

    try {
      Linking.openURL(url);
    } catch {
      console.error("Impossible d'ouvrir la carte");
    }
  }
}
